import { Navigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { onAuthStateChanged } from "firebase/auth";

import { auth } from "../lib/firebase";
import PageSkeleton from "./PageSkeleton";

const AuthRoute = ({ children }) => {

  const [user,setUser] = useState(null);
  const [loading,setLoading] = useState(true);

  useEffect(()=>{

    const unsub = onAuthStateChanged(auth,(currentUser)=>{
      setUser(currentUser);
      setLoading(false);
    });

    return ()=>unsub();

  },[]);

  if(loading) return <PageSkeleton/>;

  if(user) return <Navigate to="/admin/dashboard" replace />;

  return children;

};

export default AuthRoute;